<app-modal-frame
  [headerText]="data.edit ? CONSTANTS.HEADER_EDIT : CONSTANTS.HEADER_ADD"
  [rightButton]="{
    text: CONSTANTS.BUTTON_TEXT,
    type: BUTTON_TYPES.TEXT_BUTTON,
    disable: swapForm.invalid || swapForm.pristine,
  }"
  (emitRightClick)="clickSave()"
  (emitExit)="clickExit()"
>
  <form class="container" [formGroup]="swapForm">
    <!--ID, NAME, ACTIVE-->
    <ion-row>
      <ion-col size="3.5">
        <app-read-only-fields
          [labelText]="CONSTANTS.BODY.ID"
          [fieldText]="swapForm.get('id')?.value ?? '-'"
        ></app-read-only-fields>
      </ion-col>
      <ion-col size="3.5">
        <app-read-only-fields
          [labelText]="CONSTANTS.BODY.NAME"
          [fieldText]="swapForm.get('name')?.value"
        ></app-read-only-fields>
      </ion-col>
      <ion-col size="1.7">
        <app-form-select
          formControlName="active"
          [label]="CONSTANTS.BODY.ACTIVE"
          [options]="ACTIVE_DROPDOWN_OPTIONS"
        >
        </app-form-select>
      </ion-col>
    </ion-row>
    <!---------------------->
    <!-- Effective and Expiry Date-->
    <ion-row>
      <ion-col size="3.5">
        <div>{{ CONSTANTS.BODY.EFFECTIVE_DATE }}</div>
        <app-form-date-picker
          formControlName="effective"
          [icon]="SRC.CALENDAR"
          [minDate]="defaultEffectiveDate"
        ></app-form-date-picker>
      </ion-col>
      <ion-col size="3.5" push="1">
        <div>{{ CONSTANTS.BODY.EXPIRY_DATE }}</div>
        <app-form-date-picker
          formControlName="expires"
          [icon]="SRC.CALENDAR"
        ></app-form-date-picker>
      </ion-col>
    </ion-row>
    <!---------------------->
    <!-- Availability-->
    <ion-row>
      {{ CONSTANTS.BODY.AVAILABILITY }}
    </ion-row>
    <ion-row>
      @for (val of AVAILABILITIES; track val) {
        <ion-col size="1">
          <app-form-checkbox
            [formControlName]="val.control"
            [label]="val.label"
          ></app-form-checkbox>
        </ion-col>
      }
    </ion-row>
    <!---------------------->
    <!-- Orig Code and Sort-->
    <ion-row>
      <ion-col size="1.7">
        <app-form-text-field
          [labelText]="CONSTANTS.BODY.ORIG_CODE"
          [maxLength]="5"
          [form]="swapForm"
          [regexType]="SpecialCharacters.ALPHABET_NUMBER"
          [control]="'origCode'"
          [hasRequiredSign]="true"
        ></app-form-text-field>
      </ion-col>
      <ion-col size="1.7">
        <app-form-select
          formControlName="origSort"
          [label]="CONSTANTS.BODY.ORIG_SORT"
          [options]="DEST_SORT_OPTIONS"
        >
        </app-form-select>
      </ion-col>
    </ion-row>
    <!---------------------->
    <!-- Dest Slic and Sort-->
    <ion-row>
      <ion-col size="1.7">
        <app-form-text-field
          [labelText]="CONSTANTS.BODY.DEST_SLIC"
          [maxLength]="5"
          [form]="swapForm"
          [regexType]="SpecialCharacters.ALPHABET_NUMBER"
          [control]="'destSlic'"
          [hasRequiredSign]="true"
        ></app-form-text-field>
      </ion-col>
      <ion-col size="1.7">
        <app-form-select
          formControlName="destSort"
          [label]="CONSTANTS.BODY.DEST_SORT"
          [options]="DEST_SORT_OPTIONS"
        >
        </app-form-select>
      </ion-col>
    </ion-row>
    <!---------------------->
    <!-- Swap Slic and Sort-->
    <ion-row>
      <ion-col size="1.7">
        <app-form-text-field
          [labelText]="CONSTANTS.BODY.SWAP_SLIC"
          [maxLength]="5"
          [form]="swapForm"
          [regexType]="SpecialCharacters.ALPHABET_NUMBER"
          [control]="'swapSlic'"
          [hasRequiredSign]="true"
        ></app-form-text-field>
      </ion-col>
      <ion-col size="1.7">
        <app-form-select
          formControlName="swapSort"
          [label]="CONSTANTS.BODY.SWAP_SORT"
          [options]="DEST_SORT_OPTIONS"
        >
        </app-form-select>
      </ion-col>
    </ion-row>
    <!---------------------->
    <!-- SVC and Swap SVC-->
    <ion-row>
      <ion-col size="1.7">
        <app-form-select
          formControlName="service"
          [label]="CONSTANTS.BODY.SVC"
          [options]="SERVICE_OPTIONS"
        ></app-form-select>
      </ion-col>
      <ion-col size="1.7">
        <app-form-select
          formControlName="swapService"
          [label]="CONSTANTS.BODY.SWAP_SVC"
          [options]="SERVICE_OPTIONS"
        >
        </app-form-select>
      </ion-col>
    </ion-row>
    <!---------------------->
    <!-- LCD-->
    <ion-row>
      @for (val of LCDS; track val) {
        <ion-col size="1.7">
          <app-form-text-field
            [labelText]="val.label"
            [type]="'number'"
            [form]="swapForm"
            [regexType]="SpecialCharacters.NUMBER_ONLY"
            [control]="val.control"
          ></app-form-text-field>
        </ion-col>
      }
    </ion-row>
    <!---------------------->
    <!-- Swap Loc Role-->
    @if (data.isEdi) {
      <ion-row>
        <ion-col size="3">
          <app-form-select
            formControlName="swapPkgLocRole"
            [label]="CONSTANTS.BODY.SWAP_LOC_ROLES"
            [options]="SWAP_LOC_OPTIONS"
          >
          </app-form-select>
        </ion-col>
      </ion-row>
    }
    <!---------------------->
  </form>
</app-modal-frame>
